var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProtectPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.234375,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#A4EAF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2344 18.4167C11.2344 15.2191 11.2344 13.6203 11.6119 13.0824C11.9894 12.5445 13.4927 12.03 16.4993 11.0008L17.0721 10.8047C18.6394 10.2682 19.423 10 20.2344 10C21.0458 10 21.8294 10.2682 23.3967 10.8047L23.9695 11.0008C26.9761 12.03 28.4793 12.5445 28.8569 13.0824C29.2344 13.6203 29.2344 15.2191 29.2344 18.4167C29.2344 18.8996 29.2344 19.4234 29.2344 19.9914C29.2344 25.6294 24.9954 28.3655 22.3358 29.5273C21.6144 29.8424 21.2536 30 20.2344 30C19.2151 30 18.8544 29.8424 18.1329 29.5273C15.4733 28.3655 11.2344 25.6294 11.2344 19.9914C11.2344 19.4234 11.2344 18.8996 11.2344 18.4167Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7344 20.4L19.1629 22L22.7344 18",
    stroke: "#1D1D1D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProtectPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/protect-pdf.9197eb69afbab2cdd4dabc7e377c8fa1.svg";